export default {
	siteName: 'Dashboard Business VocaGame',
	lang: 'id',
	dev: import.meta.env.DEV,
	baseURL: import.meta.env.VITE_API_BASE_URL,
	apiURL: import.meta.env.VITE_BACKEND_API_URL,
};
